"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const RuleLink_1 = require("../RuleLink");
function SynchronisationMecanism({ explanation }) {
    return (jsx_runtime_1.jsxs("p", { children: ["Obtenu \u00E0 partir de la saisie", ' ', jsx_runtime_1.jsx(RuleLink_1.RuleLinkWithContext, { dottedName: explanation.data.dottedName }, void 0)] }, void 0));
}
exports.default = SynchronisationMecanism;
